import { MONO_CLASS } from '../../ui/Mono';

/**
 * Indicador de "armado" do bipe: a caixa tracejada que diz ao operador que o
 * leitor está ouvindo. Sem ela, um campo invisível vira um coletor sem sinal de
 * vida — o operador não sabe se pode bipar. O cursor piscando é a única pista;
 * enquanto o leitor "digita", a caixa mostra o que já chegou (`buffer`).
 *
 * Compartilhada pelo `ScanInput` (coletor/bancada de kits) e pela bancada de
 * packing no quiosque — o mesmo vocabulário visual em todo terminal de chão.
 */
const ScanArmedBox = ({ armed, buffer = '', label }) => (
    <div
        aria-live="polite"
        className={`flex min-h-[64px] items-center justify-center gap-3 rounded-xl border-2 border-dashed px-4 py-3 text-center ${
            armed
                ? 'border-mono-400 bg-mono-50 dark:border-mono-600 dark:bg-mono-900'
                : 'border-mono-200 bg-mono-100 opacity-60 dark:border-mono-800 dark:bg-mono-900'
        }`}
    >
        {armed ? <span className="inline-block h-6 w-[3px] animate-pulse bg-black dark:bg-white" /> : null}
        <span className="text-base font-semibold text-mono-700 dark:text-mono-300">
            {buffer ? (
                <span className={MONO_CLASS}>{buffer}</span>
            ) : armed ? (
                label('wms.collector.waiting_scan')
            ) : (
                label('wms.collector.scan_disabled')
            )}
        </span>
    </div>
);

export default ScanArmedBox;
